export default "__VITE_ASSET__9fba488c__"